import classnames from "classnames";
import React from "react";
interface Props {
  label: string
  sublabel?: string
  id?: string
  className?: string
  secondColumnClass?: string
  bigPadding?: boolean
  labelWidth?: number
  title?: string
  rowRef?: React.RefObject<HTMLTableRowElement>
}

const LabelledRow = ({ id, className, children, label, labelWidth, secondColumnClass, bigPadding, sublabel, title, rowRef }: React.PropsWithChildren<Props>) => {
  const secondColumnClasses = classnames({
    // s1_cell_bigpadding: bigPadding,
    [secondColumnClass]: secondColumnClass,
    s1_cell_bigpadding: bigPadding
  });
  return <tr ref={rowRef} id={id} className={className}>
    <td className="label" style={{ width: labelWidth ?? undefined }} title={title}>
      {label}
      {sublabel && <div className="text-sublabel">{sublabel}</div>}
    </td>
    <td className={secondColumnClasses} colSpan={2}>
      {children}
    </td>
  </tr >;
};

export default LabelledRow;